import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';

const { NEWTUBE_API_SERVER } = url;
const FETCH_IDNUMBER_VERIFY_REQUEST = 'foundation/hire/FETCH_IDNUMBER_VERIFY_REQUEST';
const FETCH_IDNUMBER_VERIFY_SUCCESS = 'foundation/hire/FETCH_IDNUMBER_VERIFY_SUCCESS';
const FETCH_IDNUMBER_VERIFY_FAIL = 'foundation/hire/FETCH_IDNUMBER_VERIFY_FAIL';

const FETCH_BUSINESSEMAIL_VERIFY_REQUEST = 'foundation/hire/FETCH_BUSINESSEMAIL_VERIFY_REQUEST';
const FETCH_BUSINESSEMAIL_VERIFY_SUCCESS = 'foundation/hire/FETCH_BUSINESSEMAIL_VERIFY_SUCCESS';
const FETCH_BUSINESSEMAIL_VERIFY_FAIL = 'foundation/hire/FETCH_BUSINESSEMAIL_VERIFY_FAIL';

const FETCH_EMPLOYEE_NUMBER_VERIFY_REQUEST = 'foundation/hire/FETCH_EMPLOYEE_NUMBER_VERIFY_REQUEST';
const FETCH_EMPLOYEE_NUMBER_VERIFY_SUCCESS = 'foundation/hire/FETCH_EMPLOYEE_NUMBER_VERIFY_SUCCESS';
const FETCH_EMPLOYEE_NUMBER_VERIFY_FAIL = 'foundation/hire/FETCH_EMPLOYEE_NUMBER_VERIFY_FAIL';

export default function reducer(state = {
  isEmployeeNumberVerifyLoading: false,
  isEmployeeNumberVerifySuccess: true,
}, action) {
  switch (action.type) {
    case FETCH_EMPLOYEE_NUMBER_VERIFY_REQUEST:
      return Object.assign({}, state, {
        isEmployeeNumberVerifyLoading: true,
      });
    case FETCH_EMPLOYEE_NUMBER_VERIFY_SUCCESS:
      return Object.assign({}, state, {
        isEmployeeNumberVerifyLoading: false,
        isEmployeeNumberVerifySuccess: action.response.data,
      });
    case FETCH_EMPLOYEE_NUMBER_VERIFY_FAIL:
      return Object.assign({}, state, {
        isEmployeeNumberVerifyLoading: false,
      });
    default:
      return state;
  }
}

export function fetchIdNumberVerify(type, number, date, id) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}PA/HireValidate/IDNumber?IDType=${type}&IDNumber=${number}&onboardingDate=${date}&id=${id}`,
      method: 'GET',
      types: [
        FETCH_IDNUMBER_VERIFY_REQUEST,
        FETCH_IDNUMBER_VERIFY_SUCCESS,
        FETCH_IDNUMBER_VERIFY_FAIL,
      ],
    },
  };
}

export function fetchBusinessEmailVerify(email, onboardingId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}PA/HireValidate/BusinessEmail?BusinessEmail=${email}&Id=${onboardingId}`,
      method: 'GET',
      types: [
        FETCH_BUSINESSEMAIL_VERIFY_REQUEST,
        FETCH_BUSINESSEMAIL_VERIFY_SUCCESS,
        FETCH_BUSINESSEMAIL_VERIFY_FAIL,
      ],
    },
  };
}

export function fetchEmployeeNumberVerify(prefix, number) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}PA/HireValidate/EmployeeNumber?Prefix=${prefix}&Number=${number}`,
      method: 'GET',
      types: [
        FETCH_EMPLOYEE_NUMBER_VERIFY_REQUEST,
        FETCH_EMPLOYEE_NUMBER_VERIFY_SUCCESS,
        FETCH_EMPLOYEE_NUMBER_VERIFY_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/reducers/verifyReducer.js
 **/